module.exports = __webpack_public_path__ + "img/yyw.f6b7d1e3.png";